module.exports = __webpack_public_path__ + "static/media/FiveLogo.9f32df11.png";